<template>
    <div class="basic_wrap">
        <div class="m-flex red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{ $t('我的合同') }}</div>
        </div>
        <div style="height: 40px;"></div>
        <div class="contract-wrap">
            <van-cell is-link @click="$router.push('/contracts?id='+item.id+'&status='+2)" v-for="(item,index) in list" :key="index">
				<template #title>
					<span class="custom-title">{{ item.title }}</span>
                    <span class="custom-time">{{ item.createtime }}</span>
				</template>
			</van-cell>
            <van-empty v-if="list.length == 0" :description="$t('item.noData')" />
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import {
    Empty
} from "vant";

import Fetch from "../../utils/fetch";
Vue.use(Empty);

export default {
    name: "order",
    data() {
        return {
            lang: this.$i18n.locale || "zh_cn",
            info: {},
            list: []
        };
    },
    created() {
        this.$parent.footer('item',false)
        Fetch('/user/getSubscriptionContractList').then((r) => {
                this.list = r.data;
            })
        this.getUserInfo()
    },
    mounted() {
    },
    computed: {
        time() {
            const time = this.$route.query.time
            let date = new Date(time * 1),
                year = date.getFullYear(),
                month = date.getMonth() + 1,
                strDate = date.getDate()
            if (month < 10) month = `0${month}`
            if (strDate < 10) strDate = `0${strDate}`
            return `${year}-${month}-${strDate}`
        }
    },
    methods: {
        getUserInfo() {
            Fetch('/user/info').then((r) => {
                this.info = r.data;
            })
        }
    }
}
</script>

<style lang="less" scoped>
.red_top_bg {
    position: fixed;
    .back_left {
        margin-top: 0px;
    }
}
.van-cell__title {
    display: flex;
    justify-content: space-between;
}
.custom-title {
    display: inline-block;
    padding: 0 4px;
}
.custom-time {
    color: #999;
    white-space: nowrap;
}
.contract-wrap {
    padding: 5px;
    .lis {
        display: flex;
        align-items: center;
        padding: 0 10px;
        width: 100%;
        height: 40px;
        background: #eee;
        
    }
    &>p,
    &>div {
        margin: .5em 0;
    }

    p {
        font-size: 14px;
        text-indent: 2em;

        &.h3 {
            font-size: 16px;
            text-indent: 0;
        }

        &.h4 {
            font-size: 18px;
            text-indent: 0;

        }
    }
}
</style>
